<template>
  <div class="platform-navbar">
    <router-link
      v-if="isNotSharePage"
      :to="{ name: 'root' }"
      class="datapeople-logo-link"
      @click="$emit('tracking-event', { action: 'homeLogoClicked' })"
    >
      <img
        src="@/assets/datapeople-logo.svg"
        alt="Datapeople logo"
      >
    </router-link>
    <img
      v-else
      src="@/assets/datapeople-logo.svg"
      alt="Datapeople logo"
      class="pt-1"
    >
    <div
      v-if="isNotSharePage"
      class="platform-navbar-wrapper ml-8"
    >
      <NavigationPanel
        v-bind="{ ...navProps }"
        @set-modal="$emit('set-modal', $event)"
        @tracking-event="$emit('tracking-event', $event)"
      />
      <DashboardSearchBar
        :search-term="searchTerm"
        :light="true"
        always-open
        data-testid="dashboard-search-bar"
        :placeholder="'Search'"
        v-bind="$attrs"
      />
      <SettingsPanel
        v-bind="{ ...settingsProps, ...$attrs }"
      />
    </div>
  </div>
</template>

<script>

import DashboardSearchBar from '@/components/shared/DashboardSearchBar.vue';
import SettingsPanel from '@/components/navbar/SettingsPanel.vue';
import NavigationPanel from '@/components/navbar/NavigationPanel.vue';

export default {
  name: 'PlatformNavbar',
  components: {
    DashboardSearchBar,
    SettingsPanel,
    NavigationPanel,
  },
  props: {
    isNotSharePage: { type: Boolean, default: false },
    searchTerm: { type: String, default: '' },
    navProps: { type: Object, default: () => ({}) },
    settingsProps: { type: Object, default: () => ({}) },
  },
  emits: ['set-modal', 'tracking-event'],
};
</script>
<style lang="less" scoped>
.platform-navbar {
  background-color: @white;
  display: flex;
  align-items: center;
  padding: 0 32px;
  height: 60px;
  width: 100%;
  border-bottom: 1px solid @stroke-default;

  .datapeople-logo-link {
    display: flex;
    height: 20px;
  }
  .platform-navbar-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>
